var map = {
	"./bumaga-i-prisposoblenija-dlja-cherchenija.svg": "de76",
	"./bumazhnaja-produktsija.svg": "738e4",
	"./doski-i-aksessuary-k-nim.svg": "9a47",
	"./kantseljarija-i-ofisnye-prinadlezhnosti.svg": "a23c",
	"./karandashi.svg": "b24b",
	"./lastiki.svg": "70b3",
	"./linejki.svg": "1c82",
	"./markery.svg": "dc20",
	"./mel-dlja-doski.svg": "5591",
	"./ruchki.svg": "ffcf",
	"./shtempel'naja-produktsija.svg": "f752",
	"./tetradi.svg": "7133",
	"./tochilki.svg": "149d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "586d";